import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, submit, startSubmit, stopSubmit } from "redux-form";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import {
  BASE_IMAGES_URL,
  COMMON_FAIL_MESSAGE,
  validateUrl,
  ACCESS_FILES_API_KEY,
  maxLengthObjectFc,
} from "Constants";
import { isEmpty } from "BaseFunctions";
import {
  openAdvtModal,
  advtBanners,
  insertAdvt,
  loadAdvtData,
} from "ActionsAdvertisement";
import { showError, showSuccess } from "ReduxErrorBar";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import AdvertInlineCropper from "AdvertInlineCropper";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
class AddAdvt extends BaseComponent {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.formRef = React.createRef();
    this.state = { imagedata: "", active: false };
  }

  close() {
    this.props.reset();
    this.props.openAdvtModal({ showModal: false });
    this.props.loadAdvtData({});
  }

  submitFormOn = (e) => {
    this.props.dispatch(
      startSubmit("AddAdvtForm"),
      this.props.selectedFeatures
    );
    this.props.dispatch(submit("AddAdvtForm"), this.props.selectedFeatures);
  };

  render() {
    var {
      handleSubmit,
      pristine,
      dirty,
      reset,
      submitting,
      valid,
      invalid,
      submit,
      showModal,
      toEdit,
    } = this.props;

    // var disabled = !((dirty && valid) || (edit && pristine && this.state.active));
    var disabled = pristine || invalid || submitting;

    return (
      <div>
        <div>
          <Modal
            className="modal-container"
            show={showModal.showModal === true ? true : false}
            onHide={this.close}
            animation={true}
            keyboard={false}
            backdrop="static"
            dialogClassName="modal-lg"
            enforceFocus={false}
          >
            <form onSubmit={handleSubmit(submit)} encType="multipart/form-data">
              <Modal.Header>
                <div className="import-modal-title">
                  {toEdit
                    ? LocaleStrings.advt_modal_title_edit
                    : LocaleStrings.advt_modal_title_add}
                </div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body className="scrollable-modal">
                <BasicForm
                  {...this.props}
                  onImageChange={(img) => this.setState({ active: true })}
                  ref={this.formRef}
                />
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => this.close()}
                  className="btn btn-custom-white"
                  type="button"
                >
                  {LocaleStrings.button_close}
                </button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  type="button"
                  loading={submitting}
                  onClick={this.submitFormOn}
                  disabled={disabled}
                >
                  {LocaleStrings.button_save}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

function onFormSubmit(values, dispatch, props) {
  var existsSponsor = _.filter(props.selectedFeatures, {
    bsClass: "sponsor",
    isenabled: true,
  });
  var existsExhibitor = _.filter(props.selectedFeatures, {
    bsClass: "exhibitor",
    isenabled: true,
  });
  if (
    values.isenabled == true &&
    existsSponsor.length < 1 &&
    values.internalscreen == "sponsor" &&
    values.externallink == ""
  ) {
    props.showError("Add External Link / Interal Link Please");
    props.stopSubmit("AddAdvtForm");
    return false;
  }
  if (
    values.isenabled == true &&
    existsExhibitor.length < 1 &&
    values.internalscreen == "exhibitor" &&
    values.externallink == ""
  ) {
    props.showError("Add External Link / Interal Link Please");
    props.stopSubmit("AddAdvtForm");
    return false;
  }
  if (
    existsExhibitor.length < 1 &&
    existsSponsor.length < 1 &&
    values.externallink == ""
  ) {
    props.showError("Add External Link Please");
    props.stopSubmit("AddAdvtForm");
    return false;
  }
  var data = { ...values };
  if (!isEmpty(values.relatedid)) {
    data.relatedid = values.relatedid.value;
  } else if (values.relatedid == "") {
    data.relatedid = 0;
  }
  var { session, initialValues } = props;
  var advt = initialValues;

  return new Promise((resolve, reject) => {
    return props.insertAdvt(session, data, advt, (result) => {
      if (result.error === 1) {
        props.stopSubmit("AddAdvtForm");
        props.showError(COMMON_FAIL_MESSAGE);
        return reject(result.error);
      } else if (result.error === 2) {
        props.stopSubmit("AddAdvtForm");
        props.showError(LocaleStrings.advt_form_banner_fail_alert);
        return reject();
      } else {
        props.finishOperationsCallback();
        props.showSuccess(LocaleStrings.advt_form_success_alert);
        props.openAdvtModal({ showModal: false });
        setTimeout(() => {
          props.stopSubmit("AddAdvtForm");
          props.reset();
          return resolve(result);
        }, 500);
      }
    });
  });
}

function validate(values) {
  var errors = {};
  var advtname = values.advtname;
  var bannerimg = values.bannerimg;
  var frequency = values.frequency;
  var externallink = values.externallink;
  var internalscreen = values.internalscreen;

  if (!advtname || advtname.trim() === "") {
    errors["advtname"] = LocaleStrings.required;
  }
  if (!bannerimg || bannerimg.trim() === "") {
    errors["bannerimg"] = LocaleStrings.required;
  }

  // if (!frequency) {
  //   errors["frequency"] = LocaleStrings.required;
  // } else if (frequency && frequency < 1) {
  //   errors["frequency"] = LocaleStrings.advt_form_validation_min_frequency;
  // }

  if (
    (!externallink || externallink.trim() === "") &&
    (!internalscreen || internalscreen === "")
  ) {
    errors["externallink"] = LocaleStrings.advt_form_validation_link_required;
  } else if (externallink && !validateUrl(externallink)) {
    errors["externallink"] = LocaleStrings.advt_form_validation_link_invalid;
  }

  return errors;
}

function mapStateToProps(state) {
  var toEdit = !isEmpty(state.advtEditData);
  var initVals = { screen: "overviewinline", showalways: "1" };

  if (toEdit) {
    initVals = state.advtEditData;
    initVals.showalways = state.advtEditData.showalways == 1 ? "1" : "0";
  }
  if (!toEdit) {
    initVals["isenabled"] = true;
  }

  return {
    session: state.session,
    showModal: state.advtAddModal,
    toEdit,
    initialValues: initVals,
    advtBannerOptions: state.advtBannerOptions,
    allSpeakers: state.allSpeakers,
    allSponsors: state.allSponsors,
    allExhibitors: state.allExhibitors,
    selectedFeatures: state.selectedFeatures,
  };
}

export default connect(mapStateToProps, {
  openAdvtModal,
  advtBanners,
  insertAdvt,
  loadAdvtData,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "AddAdvtForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(AddAdvt)
);

class BasicForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedScreen: {
        name: LocaleStrings.advt_form_screen_option1,
        value: "overviewinline",
        size: "1054x600",
      },
      linkedTo: "",
      imagePreviewUrl: props.initialValues.bannerimg
        ? `${BASE_IMAGES_URL}/${props.initialValues.bannerimg}?api_key=${ACCESS_FILES_API_KEY}`
        : "",
      forPositioning: "",
    };
    this.cropperRef = React.createRef();
    this.onImageSave = this.onImageSave.bind(this);
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
    var { toEdit, initialValues, advtBannerOptions } = this.props;
    var { linkedTo } = this.state;

    if (toEdit) {
      if (initialValues.internalscreen) {
        linkedTo = initialValues.internalscreen;
      }

      this.setState({ linkedTo });

      if (initialValues.screen) {
        let matched = _.filter(advtBannerOptions, (obj) => {
          return obj.value == initialValues.screen;
        });

        this.setState(
          matched.length > 0
            ? { selectedScreen: matched[0] }
            : this.state.selectedScreen
        );
      }
    }
  }

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img });

    this.props.autofill("bannerimg", img);
  };

  onImageChange = (imageAvailable) => {
    if (imageAvailable !== undefined) this.setState({ imageAvailable });
  };

  _handleSelectedScreen = (e) => {
    let value = e.target.value;
    let { advtBannerOptions } = this.props;
    // console.log("advtBannerOptions :- ", advtBannerOptions);

    let matched = _.filter(advtBannerOptions, (obj) => {
      return obj.value == value;
    });

    this.setState(matched.length > 0 ? { selectedScreen: matched[0] } : {});
    this.setState({ imagePreviewUrl: "" });
    this.props.autofill("bannerimg", "");

    this.cropperRef.current.resetImage();

    let mandateType = "";
    if (e.target.value != "" && e.target.value != null) {
      mandateType = _.find(this.props.advtBannerOptions, {
        value: e.target.value,
      }).value;
    }
    this.setState({ forPositioning: mandateType });
  };

  _handleInternalScreen = (e) => {
    let value = e.target.value;

    this.setState({ linkedTo: value });

    this.props.autofill("relatedid", "");
    this.props.autofill("externallink", "");
  };

  _handleExternalLink = (e) => {
    this.props.autofill("internalscreen", "");
    this.props.autofill("relatedid", "");

    this.setState({ linkedTo: "" });
  };

  render() {
    let {
      allSpeakers,
      allSponsors,
      allExhibitors,
      advtBannerOptions,
      initialValues,
      selectedFeatures,
    } = this.props;
    let { linkedTo, selectedScreen, imagePreviewUrl, forPositioning } =
      this.state;
    let adImagePlaceholder = "../../style/images/images/adPreview.png";
    let advertPreviewScreens = [
      {
        name: "overview",
        src: "../../style/images/advertscreens/overview.png",
      },
      {
        name: "sidemenu",
        src: "../../style/images/advertscreens/sidemenu.png",
      },
      { name: "splash", src: "../../style/images/advertscreens/splash.png" },
      { name: "popup", src: "../../style/images/advertscreens/popup.png" },
    ];
    var existsSponsor = _.filter(selectedFeatures, {
      bsClass: "sponsor",
      isenabled: true,
    });
    var existsExhibitor = _.filter(selectedFeatures, {
      bsClass: "exhibitor",
      isenabled: true,
    });

    let size = selectedScreen.size.split("x");
    let width = parseInt(size[0]);
    let height = parseInt(size[1]);

    let screen = [];
    advtBannerOptions.map((item) => {
      screen.push({
        name: item.name,
        value: item.value,
      });
    });

    let linkto = [
      { name: "Sponsor", value: "sponsor" },
      { name: "Exhibitor", value: "exhibitor" },
      // { name: "Speaker", value: "speaker" },
      // { name: "Schedules", value: "schedule" },
      // { name: "Maps", value: "map" },
      // { name: "News", value: "news" },
    ];
    let linktosponsor = [
      { name: "Sponsor", value: "sponsor" },
      // { name: "Exhibitor", value: "exhibitor" },
      // { name: "Speaker", value: "speaker" },
      // { name: "Schedules", value: "schedule" },
      // { name: "Maps", value: "map" },
      // { name: "News", value: "news" },
    ];
    let linktoexhibitor = [
      // { name: "Sponsor", value: "sponsor" },
      { name: "Exhibitor", value: "exhibitor" },
      // { name: "Speaker", value: "speaker" },
      // { name: "Schedules", value: "schedule" },
      // { name: "Maps", value: "map" },
      // { name: "News", value: "news" },
    ];

    let className = "hide";
    if (
      linkedTo === "speaker" ||
      linkedTo === "sponsor" ||
      linkedTo === "exhibitor"
    ) {
      className = "show";
    }

    let related = [];
    if (linkedTo === "speaker") {
      _.map(allSpeakers.data, (item, index) => {
        let obj = {
          label: `${item.firstname} ${item.lastname}`,
          value: item.speakerid,
        };

        related.push(obj);
      });
    } else if (linkedTo === "sponsor") {
      if (existsSponsor.length > 0) {
        _.map(allSponsors.data, (item, index) => {
          let obj = { label: `${item.name}`, value: item.sponsorid };

          related.push(obj);
        });
      }
    } else if (linkedTo === "exhibitor") {
      if (existsExhibitor.length > 0) {
        _.map(allExhibitors.data, (item, index) => {
          let obj = { label: `${item.name}`, value: item.exhibitorid };

          related.push(obj);
        });
      }
    }
    if (initialValues.hasOwnProperty("screen")) {
      forPositioning =
        forPositioning === "" ? initialValues.screen : forPositioning;
    }

    return (
      <div className="row">
        <div className=" col-sm-8 basicform">
          <Field
            name="advtname"
            label={LocaleStrings.advt_form_label_name}
            placeholder={LocaleStrings.advt_form_ph_name}
            type="text"
            component={this.renderFieldText}
            mandatory="true"
            labelposition={LABEL_POSITION_TOP}
            maxlength={MAXLENOBJ.advtname ? MAXLENOBJ.advtname : ""}
          />
          {/* {this.props.toEdit ? ( */}
          <Field
            name="isenabled"
            label="Enable/Disable"
            component={this.renderFieldCheckbox}
            type="checkbox"
            mandatory="true"
            // onChange={this.handleCapacity}
          />
          {/* ):('')} */}

          <Field
            name="screen"
            label={LocaleStrings.advt_form_label_screen}
            component={this.renderSelect}
            mandatory="true"
            labelposition={LABEL_POSITION_TOP}
            opts={screen}
            onChange={this._handleSelectedScreen.bind(this)}
          />
          {forPositioning == "splash" || forPositioning == "home" ? (
            <div className="row vertical-align-center">
              <label className="col-sm-3 control-label-top">
                {LocaleStrings.advt_form_label_advt_display}
                <span className="label-mandatory">*</span>
              </label>
              <div className={`col-sm-3`}>
                <Field
                  name="showalways"
                  label={LocaleStrings.advt_form_advt_display_option1}
                  value="1"
                  type="radio"
                  component={this.renderFieldRadio}
                />
              </div>
              <div className={`col-sm-3`}>
                <Field
                  name="showalways"
                  label={LocaleStrings.advt_form_advt_display_option2}
                  value="0"
                  type="radio"
                  component={this.renderFieldRadio}
                />
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="form-group row">
            <label className="col-sm-12 control-label-top">
              {LocaleStrings.advt_form_label_banner}
              <span className="label-mandatory">*</span>
            </label>
            <div className="col-sm-12">
              <AdvertInlineCropper
                width={width}
                height={height}
                border={10}
                onImageSave={this.onImageSave}
                onImageChange={this.onImageChange}
                imagepath={imagePreviewUrl}
                imageType="jpg"
                ref={this.cropperRef}
              />
              <div className="image-subtitle-info">
                {LocaleStrings.add_recommendedsize} {width}{" "}
                {LocaleStrings.add_wide}
                {height} {LocaleStrings.add_tall}
              </div>
              <Field name="bannerimg" component={this.renderHiddenFieldText} />
            </div>
          </div>
          <Field
            name="externallink"
            label={LocaleStrings.advt_form_label_external_link}
            placeholder={LocaleStrings.advt_form_ph_external_link}
            type="text"
            component={this.renderFieldText}
            mandatory="true"
            labelposition={LABEL_POSITION_TOP}
            onChange={this._handleExternalLink}
            maxlength={MAXLENOBJ.externallink ? MAXLENOBJ.externallink : ""}
          />

          {existsSponsor.length > 0 && existsExhibitor.length > 0 ? (
            <div>
              <div className="text-center">
                <label className="text-uppercase">{LocaleStrings.or}</label>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-md-6">
                    <Field
                      name="internalscreen"
                      label={LocaleStrings.advt_form_label_internal_link}
                      placeholder={LocaleStrings.advt_form_ph_internal_link}
                      component={this.renderSelect}
                      mandatory="true"
                      labelposition={LABEL_POSITION_TOP}
                      opts={linkto}
                      onChange={this._handleInternalScreen}
                    />
                  </div>
                  <div className={`col-md-6 ${className}`}>
                    <Field
                      name="relatedid"
                      label={LocaleStrings.advt_form_label_linked_user}
                      placeholder={LocaleStrings.advt_form_ph_linked_user}
                      component={this.renderAutoComplete}
                      mandatory="false"
                      options={related}
                      labelKey="name"
                      valueKey="value"
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : existsSponsor.length > 0 ? (
            <div>
              <div className="text-center">
                <label className="text-uppercase">{LocaleStrings.or}</label>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-md-6">
                    <Field
                      name="internalscreen"
                      label={LocaleStrings.advt_form_label_internal_link}
                      placeholder={LocaleStrings.advt_form_ph_internal_link}
                      component={this.renderSelect}
                      mandatory="true"
                      labelposition={LABEL_POSITION_TOP}
                      opts={linktosponsor}
                      onChange={this._handleInternalScreen}
                    />
                  </div>
                  <div className={`col-md-6 ${className}`}>
                    <Field
                      name="relatedid"
                      label={LocaleStrings.advt_form_label_linked_user}
                      placeholder={LocaleStrings.advt_form_ph_linked_user}
                      component={this.renderAutoComplete}
                      mandatory="false"
                      options={related}
                      labelKey="name"
                      valueKey="value"
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : existsExhibitor.length > 0 ? (
            <div>
              <div className="text-center">
                <label className="text-uppercase">{LocaleStrings.or}</label>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-md-6">
                    <Field
                      name="internalscreen"
                      label={LocaleStrings.advt_form_label_internal_link}
                      placeholder={LocaleStrings.advt_form_ph_internal_link}
                      component={this.renderSelect}
                      mandatory="true"
                      labelposition={LABEL_POSITION_TOP}
                      opts={linktoexhibitor}
                      onChange={this._handleInternalScreen}
                    />
                  </div>
                  <div className={`col-md-6 ${className}`}>
                    <Field
                      name="relatedid"
                      label={LocaleStrings.advt_form_label_linked_user}
                      placeholder={LocaleStrings.advt_form_ph_linked_user}
                      component={this.renderAutoComplete}
                      mandatory="false"
                      options={related}
                      labelKey="name"
                      valueKey="value"
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {/* <Field
          name="frequency"
          label={LocaleStrings.advt_form_label_frequency}
          placeholder={LocaleStrings.advt_form_ph_frequency}
          type="number"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        /> */}
        </div>
        <div className="col-sm-4 advert-template-container">
          {this.state.selectedScreen.value === "overviewinline" ? (
            <>
              <div className="advert-overview-cover-container">
                <img
                  style={imagePreviewUrl === "" ? { width: 135 } : {}}
                  src={
                    imagePreviewUrl != "" ? imagePreviewUrl : adImagePlaceholder
                  }
                />
              </div>
              <img src={`${advertPreviewScreens[0].src}`} />
            </>
          ) : (
            ""
          )}
          {this.state.selectedScreen.value === "sidemenu" ? (
            <>
              <div className="advert-side-menu-cover-container">
                <img
                  style={imagePreviewUrl === "" ? { width: 122 } : {}}
                  src={
                    imagePreviewUrl !== ""
                      ? imagePreviewUrl
                      : adImagePlaceholder
                  }
                />
              </div>
              <img src={`${advertPreviewScreens[1].src}`} />
            </>
          ) : (
            ""
          )}

          {this.state.selectedScreen.value === "home" ? (
            <>
              <div className="advert-popup-cover-container">
                <img
                  src={
                    imagePreviewUrl != "" ? imagePreviewUrl : adImagePlaceholder
                  }
                />
              </div>
              <img src={`${advertPreviewScreens[2].src}`} />
            </>
          ) : (
            ""
          )}
          {this.state.selectedScreen.value === "splash" ? (
            <>
              <div className="advert-splash-cover-container">
                <img
                  src={
                    imagePreviewUrl != "" ? imagePreviewUrl : adImagePlaceholder
                  }
                />
              </div>
              <img src={`${advertPreviewScreens[3].src}`} />
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
